module.exports = __webpack_public_path__ + "img/6-min.f89b62d8.jpg";